module.exports = __webpack_public_path__ + "img/mi5.6132b310.png";